


// /* eslint-disable no-unused-vars */
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// export default function JobList() {
//   const [jobs, setJobs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedJob, setSelectedJob] = useState(null);

//   const jobsPerPage = 6;

//   useEffect(() => {
//     const fetchJobs = async () => {
//       try {
//         setLoading(true);
//         const res = await axios.get(`${process.env.REACT_APP_API_URL}admin`);
//         setJobs(res.data);
//       } catch (err) {
//         console.log(err);
//         setError('Failed to load jobs');
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchJobs();
//   }, []);

//   // Calculate pagination
//   const indexOfLastJob = currentPage * jobsPerPage;
//   const indexOfFirstJob = indexOfLastJob - jobsPerPage;
//   const currentJobs = jobs.slice(indexOfFirstJob, indexOfLastJob);
//   const totalPages = Math.ceil(jobs.length / jobsPerPage);

//   const goToNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const goToPrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const openJobModal = (job) => {
//     setSelectedJob(job);
//   };

//   const closeModal = () => {
//     setSelectedJob(null);
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-indigo-600"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-7xl mx-auto p-6">
//       <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Latest Job Openings</h1>

//       {jobs.length === 0 ? (
//         <p className="text-center text-gray-500 text-lg">No jobs posted yet.</p>
//       ) : (
//         <>
//           {/* Job Grid - 6 per page */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//             {currentJobs.map((job) => (
//               <div
//                 key={job._id}
//                 onClick={() => openJobModal(job)}
//                 className="bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer overflow-hidden transform hover:-translate-y-2"
//               >
//                 {job.imageUrl ? (
//                   <img
//                     src={job.imageUrl}
//                     alt={job.title || job.companyName}
//                     className="w-full h-52 object-cover"
//                   />
//                 ) : (
//                   <div className="bg-gradient-to-br from-indigo-500 to-purple-600 h-52 flex items-center justify-center">
//                     <span className="text-white text-4xl font-bold">
//                       {job.companyName?.charAt(0).toUpperCase() || 'J'}
//                     </span>
//                   </div>
//                 )}

//                 <div className="p-6">
//                   {job.title ? (
//                     <h3 className="text-xl font-bold text-gray-800 mb-2">{job.title}</h3>
//                   ) : (
//                     <h3 className="text-xl font-bold text-gray-800 mb-2">Job Opportunity</h3>
//                   )}
//                   <p className="text-indigo-600 font-semibold text-lg mb-2">{job.companyName}</p>

//                   {job.salary && (
//                     <p className="text-green-600 font-medium mb-3">{job.salary}</p>
//                   )}
//                   { job.requirements && (
//                     <span className='text-1xl font-bold'> Requirements:
//   <p className="text-green-600 font-medium mb-3">{job.requirements}</p>
//                     </span>
                  
//                   )}

//                   {job.address && (
//                     <p className="text-gray-600 text-sm flex items-center mb-3">
//                       <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
//                         <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
//                       </svg>
//                       {job.address}
//                     </p>
//                   )}

//                   <div className="text-xs text-gray-500 flex justify-between mt-4">
//                     <span>{job.email || job.contactNumber || 'Contact via details'}</span>
//                     <span>{new Date(job.createdAt).toLocaleDateString()}</span>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Pagination Controls */}
//           {totalPages > 1 && (
//             <div className="flex justify-center items-center gap-6 mt-12">
//               <button
//                 onClick={goToPrevPage}
//                 disabled={currentPage === 1}
//                 className={`px-6 py-3 rounded-xl font-medium transition-all ${
//                   currentPage === 1
//                     ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
//                     : 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-lg'
//                 }`}
//               >
//                 ← Previous
//               </button>

//               <span className="text-lg font-medium text-gray-700">
//                 Page {currentPage} of {totalPages}
//               </span>

//               <button
//                 onClick={goToNextPage}
//                 disabled={currentPage === totalPages}
//                 className={`px-6 py-3 rounded-xl font-medium transition-all ${
//                   currentPage === totalPages
//                     ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
//                     : 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-lg'
//                 }`}
//               >
//                 Next →
//               </button>
//             </div>
//           )}
//         </>
//       )}

//       {/* Job Detail Modal */}
//       {selectedJob && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50"
//           onClick={closeModal}
//         >
//           <div
//             className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto"
//             onClick={(e) => e.stopPropagation()}
//           >
//             {selectedJob.imageUrl ? (
//               <img
//                 src={selectedJob.imageUrl}
//                 alt={selectedJob.title || selectedJob.companyName}
//                 className="w-full h-64 object-cover rounded-t-2xl"
//               />
//             ) : (
//               <div className="bg-gradient-to-br from-indigo-500 to-purple-600 h-64 flex items-center justify-center rounded-t-2xl">
//                 <span className="text-white text-6xl font-bold">
//                   {selectedJob.companyName?.charAt(0).toUpperCase() || 'J'}
//                 </span>
//               </div>
//             )}

//             <div className="p-8">
//               <div className="flex justify-between items-start mb-6">
//                 <div>
//                   <h2 className="text-3xl font-bold text-gray-900 mb-2">
//                     {selectedJob.title || 'Job Opportunity'}
//                   </h2>
//                   <p className="text-2xl font-semibold text-indigo-600">
//                     {selectedJob.companyName}
//                   </p>
//                 </div>
//                 <button
//                   onClick={closeModal}
//                   className="text-gray-500 hover:text-gray-700 text-3xl"
//                 >
//                   ×
//                 </button>
//               </div>

//               {selectedJob.salary && (
//                 <div className="mb-6">
//                   <span className="text-green-600 text-2xl font-bold">{selectedJob.salary}</span>
//                 </div>
//               )}

//               {selectedJob.address && (
//                 <p className="text-gray-700 flex items-center gap-2 mb-6">
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                     <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
//                   </svg>
//                   <span className="text-lg">{selectedJob.address}</span>
                
//                 </p>
//               )}
//               {selectedJob.requirements && (
//                 <p className="text-gray-700 flex items-center gap-2 mb-6">
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                     <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
//                   </svg>
//                   <span className="text-lg">{selectedJob.requirements}</span>
                
//                 </p>
//               )}

//               {/* Full Description */}
//               {(selectedJob.writeUp || selectedJob.description) && (
//                 <div className="mb-8">
//                   <h3 className="text-xl font-bold text-gray-800 mb-4">Job Description</h3>
//                   <div
//                     className="text-gray-700 leading-relaxed text-base prose prose-lg max-w-none"
//                     dangerouslySetInnerHTML={{
//                       __html: (selectedJob.writeUp || selectedJob.description || '')
//                         .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
//                         .replace(/\n/g, '<br />'),
//                     }}
//                   />
//                 </div>
//               )}

//               {/* Contact Info */}
//               <div className="border-t pt-6">
//                 <h3 className="text-xl font-bold text-gray-800 mb-4">How to Apply</h3>
//                 <div className="space-y-3 text-lg">
//                   {selectedJob.email && (
//                     <p>
//                       <strong>Email:</strong>{' '}
//                       <a href={`mailto:${selectedJob.email}`} className="text-indigo-600 hover:underline">
//                         {selectedJob.email}
//                       </a>
//                     </p>
//                   )}
//                   {selectedJob.contactNumber && (
//                     <p>
//                       <strong>Phone:</strong>{' '}
//                       <a href={`tel:${selectedJob.contactNumber}`} className="text-indigo-600 hover:underline">
//                         {selectedJob.contactNumber}
//                       </a>
//                     </p>
//                   )}
//                   <p className="text-sm text-gray-500 mt-4">
//                     Posted on: {new Date(selectedJob.createdAt).toLocaleDateString('en-US', {
//                       year: 'numeric',
//                       month: 'long',
//                       day: 'numeric',
//                     })}
//                   </p>
//                 </div>
//               </div>

//               <button
//                 onClick={closeModal}
//                 className="mt-8 w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-4 rounded-xl transition"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }




/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Heart, Share2, Eye } from 'lucide-react';

export default function JobList() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedJob, setSelectedJob] = useState(null);

  // Engagement tracking
  const [likedJobs, setLikedJobs] = useState(new Set());

  const jobsPerPage = 6;

  // Fetch Jobs
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${process.env.REACT_APP_API_URL}admin`);
        setJobs(res.data);
      } catch (err) {
        console.error(err);
        setError('Failed to load jobs');
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, []);

  // Open Modal + Record View
  const openJobModal = async (job) => {
    setSelectedJob(job);

    // Record view (public - no login required)
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}admin/${job._id}/view`);
      
      // Update view count locally
      setJobs(prev => prev.map(j => 
        j._id === job._id ? { ...j, views: (j.views || 0) + 1 } : j
      ));
    } catch (err) {
      console.log("View recording failed", err);
    }
  };

  const closeModal = () => {
    setSelectedJob(null);
  };

  // Handle Like (Public)
  const handleLike = async (jobId, e) => {
    e.stopPropagation(); // Prevent opening modal

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}admin/${jobId}/like`);

      const isNowLiked = !likedJobs.has(jobId);

      if (isNowLiked) {
        setLikedJobs(prev => new Set(prev).add(jobId));
      } else {
        setLikedJobs(prev => {
          const newSet = new Set(prev);
          newSet.delete(jobId);
          return newSet;
        });
      }

      // Update likes count in main list
      setJobs(prevJobs =>
        prevJobs.map(job =>
          job._id === jobId ? { ...job, likes: res.data.likes } : job
        )
      );

      // Update in modal if open
      if (selectedJob && selectedJob._id === jobId) {
        setSelectedJob(prev => ({ ...prev, likes: res.data.likes }));
      }
    } catch (err) {
      console.error("Like failed", err);
    }
  };

  // Handle Share (Public)
  const handleShare = async (job, e) => {
    e.stopPropagation();

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}admin/${job._id}/share`);

      // Update share count locally
      setJobs(prevJobs =>
        prevJobs.map(j =>
          j._id === job._id ? { ...j, shares: (j.shares || 0) + 1 } : j
        )
      );

      const shareUrl = `${window.location.origin}/job/${job._id}`;
      await navigator.clipboard.writeText(shareUrl);

      alert(`✅ Link copied!\n${shareUrl}`);
    } catch (err) {
      console.error("Share failed", err);
      alert("Job shared successfully!");
    }
  };

  // Pagination
  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = jobs.slice(indexOfFirstJob, indexOfLastJob);
  const totalPages = Math.ceil(jobs.length / jobsPerPage);

  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const goToPrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-indigo-600"></div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Latest Job Openings</h1>

      {error && <p className="text-red-500 text-center mb-6">{error}</p>}

      {jobs.length === 0 ? (
        <p className="text-center text-gray-500 text-lg">No jobs posted yet.</p>
      ) : (
        <>
          {/* Job Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {currentJobs.map((job) => (
              <div
                key={job._id}
                onClick={() => openJobModal(job)}
                className="bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer overflow-hidden transform hover:-translate-y-2"
              >
                {/* Image Section */}
                {job.imageUrl ? (
                  <img
                    src={job.imageUrl}
                    alt={job.title || job.companyName}
                    className="w-full h-52 object-cover"
                  />
                ) : (
                  <div className="bg-gradient-to-br from-indigo-500 to-purple-600 h-52 flex items-center justify-center">
                    <span className="text-white text-4xl font-bold">
                      {job.companyName?.charAt(0).toUpperCase() || 'J'}
                    </span>
                  </div>
                )}

                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-2 line-clamp-2">
                    {job.title || 'Job Opportunity'}
                  </h3>
                  
                  <p className="text-indigo-600 font-semibold text-lg mb-2">{job.companyName}</p>

                  {job.salary && (
                    <p className="text-green-600 font-medium mb-3">{job.salary}</p>
                  )}

                  {job.requirements && (
                    <p className="text-sm text-gray-600 line-clamp-2 mb-4">
                      {job.requirements}
                    </p>
                  )}

                  {job.address && (
                    <p className="text-gray-600 text-sm flex items-center mb-4">
                      📍 {job.address}
                    </p>
                  )}

                  {/* Engagement Stats */}
                  <div className="flex items-center justify-between text-sm pt-4 border-t">
                    <button
                      onClick={(e) => handleLike(job._id, e)}
                      className="flex items-center gap-1.5 hover:text-red-500 transition-colors"
                    >
                      <Heart
                        className={`w-5 h-5 transition ${likedJobs.has(job._id) ? 'fill-red-500 text-red-500' : 'text-gray-400'}`}
                      />
                      <span className="font-medium">{job.likes || 0}</span>
                    </button>

                    <div className="flex items-center gap-1.5 text-gray-500">
                      <Eye className="w-5 h-5" />
                      <span>{job.views || 0}</span>
                    </div>

                    <button
                      onClick={(e) => handleShare(job, e)}
                      className="flex items-center gap-1.5 hover:text-blue-600 transition-colors"
                    >
                      <Share2 className="w-5 h-5" />
                      <span>{job.shares || 0}</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex justify-center items-center gap-6 mt-12">
              <button
                onClick={goToPrevPage}
                disabled={currentPage === 1}
                className={`px-6 py-3 rounded-xl font-medium transition-all ${
                  currentPage === 1
                    ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                    : 'bg-indigo-600 text-white hover:bg-indigo-700'
                }`}
              >
                ← Previous
              </button>

              <span className="text-lg font-medium text-gray-700">
                Page {currentPage} of {totalPages}
              </span>

              <button
                onClick={goToNextPage}
                disabled={currentPage === totalPages}
                className={`px-6 py-3 rounded-xl font-medium transition-all ${
                  currentPage === totalPages
                    ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                    : 'bg-indigo-600 text-white hover:bg-indigo-700'
                }`}
              >
                Next →
              </button>
            </div>
          )}
        </>
      )}

      {/* Job Detail Modal */}
      {selectedJob && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-50"
          onClick={closeModal}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Image Header */}
            {selectedJob.imageUrl ? (
              <img
                src={selectedJob.imageUrl}
                alt={selectedJob.title}
                className="w-full h-64 object-cover rounded-t-2xl"
              />
            ) : (
              <div className="bg-gradient-to-br from-indigo-500 to-purple-600 h-64 flex items-center justify-center rounded-t-2xl">
                <span className="text-white text-6xl font-bold">
                  {selectedJob.companyName?.charAt(0).toUpperCase() || 'J'}
                </span>
              </div>
            )}

            <div className="p-8">
              <div className="flex justify-between items-start mb-6">
                <div>
                  <h2 className="text-3xl font-bold text-gray-900">
                    {selectedJob.title || 'Job Opportunity'}
                  </h2>
                  <p className="text-2xl font-semibold text-indigo-600 mt-1">
                    {selectedJob.companyName}
                  </p>
                </div>
                <button onClick={closeModal} className="text-4xl text-gray-400 hover:text-gray-600">×</button>
              </div>

              {selectedJob.salary && (
                <p className="text-3xl font-bold text-green-600 mb-6">{selectedJob.salary}</p>
              )}

              {/* Engagement Bar in Modal */}
              <div className="flex items-center gap-8 py-4 border-y mb-8">
                <button onClick={(e) => handleLike(selectedJob._id, e)} className="flex items-center gap-3 text-2xl hover:text-red-500 transition">
                  <Heart className={`w-9 h-9 ${likedJobs.has(selectedJob._id) ? 'fill-red-500 text-red-500' : ''}`} />
                  <span className="font-semibold">{selectedJob.likes || 0}</span>
                </button>

                <div className="flex items-center gap-3 text-2xl text-gray-500">
                  <Eye className="w-9 h-9" />
                  <span>{selectedJob.views || 0}</span>
                </div>

                <button onClick={(e) => handleShare(selectedJob, e)} className="flex items-center gap-3 text-2xl hover:text-blue-600 transition">
                  <Share2 className="w-9 h-9" />
                  <span>{selectedJob.shares || 0}</span>
                </button>
              </div>

              {/* Rest of your original modal content */}
              {selectedJob.requirements && (
                <div className="mb-6">
                  <h3 className="font-bold text-lg mb-2">Requirements</h3>
                  <p className="text-gray-700">{selectedJob.requirements}</p>
                </div>
              )}

              {selectedJob.address && (
                <p className="text-gray-700 flex items-center gap-2 mb-6">
                  📍 {selectedJob.address}
                </p>
              )}

              {(selectedJob.writeUp || selectedJob.description) && (
                <div className="mb-8">
                  <h3 className="text-xl font-bold mb-3">Job Description</h3>
                  <div className="text-gray-700 leading-relaxed">
                    {selectedJob.writeUp || selectedJob.description}
                  </div>
                </div>
              )}

              <div className="border-t pt-6">
                <h3 className="text-xl font-bold mb-4">How to Apply</h3>
                <div className="space-y-3">
                  {selectedJob.email && (
                    <p>
                      <strong>Email:</strong>{' '}
                      <a href={`mailto:${selectedJob.email}`} className="text-indigo-600 hover:underline">
                        {selectedJob.email}
                      </a>
                    </p>
                  )}
                  {selectedJob.contactNumber && (
                    <p>
                      <strong>Phone:</strong>{' '}
                      <a href={`tel:${selectedJob.contactNumber}`} className="text-indigo-600 hover:underline">
                        {selectedJob.contactNumber}
                      </a>
                    </p>
                  )}
                </div>
              </div>

              <button
                onClick={closeModal}
                className="mt-10 w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-4 rounded-xl transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}